import { TagList } from 'components/layout/modals/components';
import React, { useState, useEffect } from 'react';

const MultiDropdownEditable = ({
	values = [],
	textKey = 'text',
	disabled = false,
	onRemoveValue,
	className = '',
	customStyles = {},
	children,
	isEditing = false,
	onToggleEditing = () => {}
}) => {
	const [isEditingState, setIsEditingState] = useState(isEditing);

	const toggleEditing = e => {
		e.preventDefault();
		setIsEditingState(!isEditingState);
		onToggleEditing(!isEditingState);
	};

	useEffect(() => {
		setIsEditingState(isEditing);
	}, [isEditing]);

	const renderDisplayMode = () => {
		return (
			<div className="multidropdown-editable-display">
				<TagList
					tags={values}
					onRemove={value => onRemoveValue(value)}
					getTagVariant={value => 'default'}
					textKey={textKey}
				/>
			</div>
		);
	};

	const renderEditMode = () => {
		return <div className="multidropdown-editable-edit">{children}</div>;
	};

	return (
		<div
			className={`multidropdown-editable ${isEditingState ? 'editing' : ''} ${className}`}
			style={{
				...(customStyles?.control || {})
			}}>
			{isEditingState ? renderEditMode() : renderDisplayMode()}
			<div className="field-actions">
				{!disabled && (
					<button
						className={`add-close-btn ${isEditingState ? 'save' : 'add'}`}
						title={isEditingState ? 'Save' : 'Add'}
						onClick={toggleEditing}>
						<img
							src={`/ats/icons/${isEditingState ? 'check' : 'plus'}-white-icon.svg`}
							alt="Add/Save"
						/>
					</button>
				)}
			</div>
		</div>
	);
};

export default MultiDropdownEditable;
